import { useMutation, useQueryClient } from "@tanstack/react-query";
import type { FinancialTransactionWithIdAndTerreiroId } from "../repositories/incoming.repository";
import { outgoingRepository } from "../repositories/outgoing.repository";
import { invalidateAccountBalanceQueries } from "./invalidateAccountBalanceQueries";
import { invalidateInventoryStorageQueries } from "./useTerreiroInventoryListQuery";
import { invalidateSupplyPlanQueries } from "./useSupplyPlanQuery";
import { invalidateFinancialListQueries } from "./invalidateFinancialListQueries";

/**
 * Mutation hook to edit an outgoing transaction (saida).
 * Uses repository for network call and performs targeted invalidation on settle.
 */
export function useEditOutgoingMutation(id: string) {
  const qc = useQueryClient();
  const mutationKey = ["outgoing", id, "edit"];

  return useMutation<unknown, Error, FinancialTransactionWithIdAndTerreiroId>({
    mutationKey,
    mutationFn: (payload) => outgoingRepository.editOutgoing(payload),
    retry: 0,
    onSettled: (_data, _error, variables) => {
      return Promise.all([
        invalidateSupplyPlanQueries(qc, variables.terreiroId, variables.mediumId),
        invalidateInventoryStorageQueries(
          qc,
          variables.terreiroId,
          variables.mediumId,
        ),
        qc.invalidateQueries({ queryKey: ["outgoing", id] }),
        invalidateFinancialListQueries(
          qc,
          "outcome",
          variables.terreiroId,
          variables.mediumId,
        ),
        invalidateAccountBalanceQueries(qc, {
          terreiroId: variables.terreiroId,
          mediumId: variables.mediumId,
        }),
      ]);
    },
  });
}
